<template>
  <div class="header">
    <div class="navheader">
      <div class="logocenter">
        <div class="logo">
          <van-image src="/img/logo.png"></van-image>
        </div>
        <van-search
          v-model="searchValue"
          placeholder="7000万人都在看"
          @search="onSearch"
        />
      </div>

      <div class="tabnav" v-if="!view">
        <van-tabs
          title-active-color="#1989fa "
          color="#1989fa"
          line-width="10"
          title-inactive-color="#333"
          :sticky="true"
          v-model="active"
          @click="onClick"
        >
          <van-tab
            v-for="item in navlist"
            :title="item.name"
            :key="item.id"
            :name="item.id"
          ></van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="right-footer" v-if="bool">
      <!--      <div class="copyLink t">-->
      <!--        <div><i class="iconfont icon-lianjie"></i></div>-->
      <!--        <div>复制</div>-->
      <!--      </div>-->
      <div class="Top t" @click="returnTop">
        <div><i class="iconfont icon-fanhuidingbu"></i></div>
        <div>顶部</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getChannel } from "../commJs/api";

export default {
  props: ["view", "index"],
  data() {
    return {
      bool: false,
      searchValue: "",
      active: 1,
      navlist: [],
    };
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.syncActiveFromRoute();
      },
    },
  },
  methods: {
    //来自组件
    parentHandleclick(channelId) {
      if (channelId != null) {
        this.active = Number(channelId);
        return;
      }
      this.syncActiveFromRoute();
    },
    syncActiveFromRoute() {
      const routeId =
        this.$route.name === "channe" ? Number(this.$route.params.id) : 1;
      this.active = Number.isNaN(routeId) ? 1 : routeId;
    },
    onSearch() {
      this.$router.push({ name: "search", params: { keys: this.searchValue } });
    },
    onClick(idx) {
      const current = this.navlist.find(
        (item) => String(item.id) === String(idx),
      );
      if (!current) return;

      if (current.type === 2) {
        window.open(current.outlinkUrl, "_blank");
        return;
      }

      if (
        this.$route.name === "channe" &&
        String(this.$route.params.id) === String(idx) &&
        Number(this.$route.query.isHomepage || 0) ===
          Number(current.isHomepage || 0)
      ) {
        return;
      }

      this.$router.push({
        name: "channe",
        params: { id: idx },
        query: { isHomepage: current.isHomepage },
      });
    },
    returnTop() {
      let ksHeight = document.documentElement.offsetHeight;
      let scrollT =
        document.documentElement.scrollTop || document.body.scrollTop;
      let scrollH = document.body.scrollHeight;
      if (ksHeight + scrollT >= scrollH + 100) {
        window.scrollBy(0, -ksHeight);
      }
    },
    handleScroll() {
      let ksHeight = document.documentElement.offsetHeight;
      let scrollT =
        document.documentElement.scrollTop || document.body.scrollTop;
      let scrollH = document.body.scrollHeight;
      if (ksHeight + scrollT > scrollH) {
        this.bool = true;
      } else {
        this.bool = false;
      }
      return this.bool;
    },
    //   getMenu() {
    //     console.log("old");
    //     let _this = this;
    //     let cache = localStorage.getItem("menuUpTime");
    //     let menuCache = localStorage.getItem("menu") || 0;
    //     if (Date.parse(new Date()) - cache > 5 * 60 * 1000 || !menuCache) {
    //       getChannel().then((res) => {
    //         if (res.code === 200) {
    //           _this.navlist = res.data.channels;
    //           localStorage.setItem("menu", JSON.stringify(res.data.channels));
    //           localStorage.setItem("menuUpTime", Date.parse(new Date()));
    //         }
    //       });
    //     } else {
    //       _this.navlist = JSON.parse(localStorage.getItem("menu")) || 0;
    //     }
    //     // this.$parent.getIndex();
    //   },
    // },
    //  new
    getMenu() {
      getChannel().then((res) => {
        console.log(res);
        if (res.success === "true") {
          this.navlist = res.data;
          // localStorage.setItem("menu", JSON.stringify(res.data));
          // localStorage.setItem("menuUpTime", Date.parse(new Date()));
        }
      });
      // let _this = this;
      // let cache = localStorage.getItem("menuUpTime");
      // let menuCache = localStorage.getItem("menu") || 0;
      // if (Date.parse(new Date()) - cache > 5 * 60 * 1000 || !menuCache) {
      //   getChannel().then((res) => {
      //     console.log(res);
      //     if (res.success === "true") {
      //       _this.navlist = res.data;
      //       localStorage.setItem("menu", JSON.stringify(res.data));
      //       localStorage.setItem("menuUpTime", Date.parse(new Date()));
      //     }
      //   });
      // } else {
      //   _this.navlist = JSON.parse(localStorage.getItem("menu")) || 0;
      // }
      // this.$parent.getIndex();
    },
  },
  mounted() {
    this.getMenu();
    // let idx = this.$route.query.idx
    // this.active = idx
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less">
.header {
  z-index: 20;
  position: sticky;
  top: 0;
  left: 0;
}

.right-footer {
  position: fixed;
  right: 10px;
  bottom: 90px;
  z-index: 99999;

  .t {
    padding: 10px;
    font-size: 14px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
  }
}

.van-tab--active {
  //font-weight: bold !important;
  //font-size: 18px !important;;
}

.van-tabs__line {
  border-radius: 0 !important;
  height: 2px !important;
  z-index: 99;
  width: 15px !important;
  bottom: 15px !important;
}

.van-tabs__nav {
  background: #fff;

  &:after {
    content: "";
    display: none;
    position: fixed;
    right: 0;
    height: 100%;
    width: 40px;
    height: 50px;
    pointer-events: none;
    background-image: -webkit-gradient(
      linear,
      right top,
      left top,
      from(#eaebf1),
      to(rgba(234, 235, 241, 0))
    );
    background-image: -webkit-linear-gradient(
      right,
      #eaebf1 0%,
      rgba(234, 235, 241, 0) 100%
    );
    background-image: linear-gradient(
      -90deg,
      #eaebf1 0%,
      rgba(234, 235, 241, 0) 100%
    );
  }
}

.van-tabs__wrap--scrollable .van-tab {
  padding: 0 6px !important;
  margin-right: 10px;
}
</style>
<style scoped lang="less">
.header {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.07);

  .logocenter {
    position: relative;
    z-index: 888;
    display: flex;

    .logo {
      width: 40%;
      padding: 10px 15px 7px 15px;
      line-height: 0;
    }
  }

  .tabnav {
    background: #fff;
  }
}
</style>
